import styled from "styled-components"

export const DownloadButton = styled.button`
  margin-left: 0.75rem;
  color: var(--clr-text-blue);
  border: none;
  background: none;
  cursor: pointer;

  font-family: var(--ff-primary);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.6875rem; /* 225% */
  letter-spacing: 0.00169rem;
`
